import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0c5273', dark: '#083e58', light: '#e5f2f6' },
    secondary: { main: '#087e8b', dark: '#05636d', light: '#e3f5f5' },
    background: { default: '#f4f7fa', paper: '#ffffff' },
    text: { primary: '#142b3d', secondary: '#617586' },
    divider: '#e4ebf0',
    success: { main: '#168567' },
    warning: { main: '#c67a16' },
    error: { main: '#c44747' }
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.035em' },
    h2: { fontWeight: 800, letterSpacing: '-0.025em' },
    h3: { fontWeight: 750, letterSpacing: '-0.02em' },
    h4: { fontWeight: 750, letterSpacing: '-0.02em' },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, textTransform: 'none' }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { minHeight: '100vh', backgroundColor: '#f4f7fa' },
        '::selection': { backgroundColor: '#bfe6ea', color: '#102c44' }
      }
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 9, minHeight: 38, paddingInline: 16 },
        contained: { boxShadow: '0 7px 16px rgba(12, 82, 115, 0.15)' }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        elevation1: { boxShadow: '0 10px 30px rgba(21, 54, 76, 0.07)' }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: '1px solid #e4ebf0',
          borderRadius: 14,
          boxShadow: '0 10px 30px rgba(21, 54, 76, 0.055)',
          overflow: 'hidden'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#f1f6f8',
          color: '#425d70',
          fontSize: '0.75rem',
          fontWeight: 800,
          letterSpacing: '0.045em',
          textTransform: 'uppercase'
        },
        root: { borderColor: '#e8eef2', padding: '15px 18px' }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: { '&:hover': { backgroundColor: '#f8fbfc' } }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10, backgroundColor: '#fff' }
      }
    },
    MuiSelect: {
      defaultProps: { size: 'small' }
    },
    MuiTabs: {
      styleOverrides: {
        root: { borderBottom: '1px solid #e4ebf0' },
        indicator: { height: 3, borderRadius: '3px 3px 0 0' }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 700, minHeight: 48 }
      }
    },
    MuiAlert: {
      styleOverrides: { root: { borderRadius: 10 } }
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 16 } }
    }
  }
});

export default theme;
